<template>
  <div class="page" :style="themeStyle">
    <div v-if="!loaded" class="loading">Loading</div>
    <div v-if="loaded" class="root">

      <!-- Top marquee line -->
      <div class="marquee-line">
        <div class="marquee-inner">
          <span v-for="n in 8" :key="n" class="marquee-item">{{ loName }} × {{ realtorName }} &nbsp;·&nbsp; </span>
        </div>
      </div>

      <!-- Nav -->
      <nav class="nav">
        <img v-if="loinfo && loinfo.main_logo" :src="loinfo.main_logo" class="nav-logo" />
        <a class="nav-cta" :href="applyRightLink">{{ heroPrimaryText }}</a>
      </nav>

      <!-- Hero center -->
      <section class="hero-center">
        <div class="hc-eyebrow">
          <div class="ey-dash"></div>
          <span>Mortgage &amp; Real Estate</span>
          <div class="ey-dash"></div>
        </div>
        <h1 class="hc-h1" v-html="heroH1Html"></h1>
        <p class="hc-body">{{ heroBody }}</p>
        <div class="hc-btns">
          <a class="hc-btn" :href="applyRightLink">{{ heroPrimaryText }}</a>
          <a v-if="applyLeftLink" class="hc-btn-text" :href="applyLeftLink">{{ heroSecondaryText }} →</a>
        </div>
      </section>

      <!-- Cards row — horizontal, editorial -->
      <section class="cards-row">

        <div class="pearl-card lo-pcard">
          <div class="pc-num">01</div>
          <div class="pc-top">
            <img v-if="loinfo && loinfo.lo_image" :src="loinfo.lo_image" class="pc-photo" />
            <div class="pc-side">
              <div class="pc-label">Loan Officer</div>
              <div class="pc-name">{{ loName }}</div>
              <div class="pc-role">{{ loTitle }}</div>
              <div v-if="loinfo && loinfo.nmls" class="pc-nmls">NMLS {{ (loinfo.nmls || "").trim() }}</div>
            </div>
          </div>
          <div class="pc-separator lo-sep"></div>
          <div class="pc-contacts">
            <a v-if="loinfo && loinfo.phone_number" :href="'tel:' + loinfo.phone_number" class="pc-ct lo-ct">{{ loinfo.phone_number }}</a>
            <a v-if="loinfo && loinfo.email" :href="'mailto:' + loinfo.email" class="pc-ct lo-ct">{{ loinfo.email }}</a>
          </div>
          <a class="pc-apply lo-apply" :href="applyRightLink">{{ heroPrimaryText }}</a>
        </div>

        <div class="pearl-divider">
          <div class="pd-line"></div>
          <div class="pd-diamond">◆</div>
          <div class="pd-line"></div>
        </div>

        <div class="pearl-card re-pcard">
          <div class="pc-num re-num">02</div>
          <div class="pc-top">
            <img v-if="realtor && realtor.headshot_url" :src="realtor.headshot_url" class="pc-photo" />
            <div class="pc-side">
              <div class="pc-label re-lbl">Partner</div>
              <div class="pc-name">{{ realtorName }}</div>
              <div class="pc-role">{{ realtor && realtor.brokerage_name }}</div>
            </div>
          </div>
          <div class="pc-separator re-sep"></div>
          <div class="pc-contacts">
            <a v-if="realtor && realtor.phone_number" :href="'tel:' + realtor.phone_number" class="pc-ct re-ct">{{ realtor.phone_number }}</a>
            <a v-if="realtor && realtor.email" :href="'mailto:' + realtor.email" class="pc-ct re-ct">{{ realtor.email }}</a>
            <a v-if="realtor && realtor.website_url" :href="realtor.website_url" class="pc-ct re-ct" target="_blank" rel="noreferrer">Website →</a>
          </div>
        </div>

      </section>

      <!-- Footer line -->
      <footer class="footer-strip">
        <span>{{ loName }}</span>
        <span class="fs-sep">·</span>
        <span>{{ loTitle }}</span>
        <span class="fs-sep">·</span>
        <span v-if="loinfo && loinfo.nmls">NMLS {{ (loinfo.nmls || "").trim() }}</span>
      </footer>

    </div>
  </div>
</template>

<script>
import coBrandMixin from "../../mixins/coBrandMixin.js";
const BRAND_COLORS = {
  zonalending: { primary: "#eb610a", accent: "#646363" },
  radiantmortgage: { primary: "#1C1F39", accent: "#DB9457" },
  conradmortgage: { primary: "#4a4b4b", accent: "#d4af37" },
  theimgteam: { primary: "#ff6633", accent: "#4a4c54" },
  responsivemortgage: { primary: "#07212c", accent: "#FF7F47" },
  kpmortgage: { primary: "#0D2821", accent: "#34BFC6" },
  ignitemortgage: { primary: "#000000", accent: "#00b1eb" },
  goldstarfinancial: { primary: "#0b1726", accent: "#c69c39" },
};
function getBrandKey(email) {
  if (!email) return null;
  return email.slice(email.indexOf("@") + 1).toLowerCase().split(".")[0] || null;
}
export default {
  name: "CoBrandPearl",
  mixins: [coBrandMixin],
  computed: {
    brandKey() { const k = getBrandKey(this.loinfo?.email); return (k && BRAND_COLORS[k]) ? k : "goldstarfinancial"; },
    palette() { return BRAND_COLORS[this.brandKey] || BRAND_COLORS.goldstarfinancial; },
    themeStyle() { return { "--p": this.palette.primary, "--a": this.palette.accent }; },
    heroH1Html() {
      const h = (this.realtor?.header1 || this.loinfo?.header1 || "").trim();
      if (!h) return "Your home awaits,<br/><em>let's begin.</em>";
      const parts = h.split(",");
      if (parts.length > 1) return `${parts[0].trim()}<br/><em>${parts.slice(1).join(",").trim()}</em>`;
      return h;
    },
    heroPrimaryText() { return this.loinfo?.right_button_text || "Apply Now"; },
    heroSecondaryText() { return this.loinfo?.left_button_text || "Schedule Appointment"; },
    heroBody() {
      const m = (this.realtor?.main || this.loinfo?.main || "").trim();
      if (m) return m;
      return [this.loinfo?.text_section_body_p1, this.loinfo?.text_section_body_p2].filter(Boolean).join(" ").trim()
        || this.loinfo?.footer_slogan || "Start your application in minutes and we'll guide you from application through closing.";
    },
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Libre+Baskerville:ital,wght@0,400;0,700;1,400&family=Nunito:wght@300;400;500;600&display=swap');

.page {
  min-height: 100vh;
  background: #faf8f4;
  color: #1c1a16;
  font-family: 'Nunito', sans-serif;
  --p: #0b1726;
  --a: #c69c39;
  --bg: #faf8f4;
  --card-bg: #ffffff;
  --border: rgba(28,26,22,0.1);
  --muted: #7a7468;
  overflow: hidden;
}
.root { display: flex; flex-direction: column; min-height: 100vh; }

/* MARQUEE */
.marquee-line { background: var(--p); overflow: hidden; white-space: nowrap; height: 32px; display: flex; align-items: center; }
.marquee-inner { display: inline-flex; animation: scroll 30s linear infinite; }
.marquee-item { font-size: 10px; font-weight: 500; letter-spacing: 0.18em; text-transform: uppercase; color: rgba(255,255,255,0.4); padding: 0 4px; }
@keyframes scroll { from { transform: translateX(0); } to { transform: translateX(-50%); } }

/* NAV */
.nav { display: flex; align-items: center; justify-content: space-between; padding: 22px 60px; border-bottom: 1px solid var(--border); }
.nav-logo { width: 150px; max-height:76px; object-fit: contain; }
.nav-cta { font-size: 11px; font-weight: 600; letter-spacing: 0.12em; text-transform: uppercase; text-decoration: none; background: var(--p); color: #fff; padding: 10px 22px; border-radius: 4px; transition: opacity 0.2s; }
.nav-cta:hover { opacity: 0.88; }

/* HERO CENTER */
.hero-center { text-align: center; padding: 72px 60px 52px; max-width: 760px; margin: 0 auto; }
.hc-eyebrow { display: flex; align-items: center; justify-content: center; gap: 16px; margin-bottom: 24px; color: var(--muted); font-size: 10px; letter-spacing: 0.2em; text-transform: uppercase; }
.ey-dash { width: 32px; height: 1px; background: var(--border); }
.hc-h1 { font-family: 'Libre Baskerville', serif; font-size: clamp(36px, 5vw, 64px); font-weight: 700; line-height: 1.12; color: var(--p); margin: 0 0 22px; }
.hc-h1 em { font-style: italic; color: var(--a); font-weight: 400; }
.hc-body { font-size: 15px; line-height: 1.8; color: var(--muted); margin-bottom: 36px; font-weight: 300; }
.hc-btns { display: flex; align-items: center; justify-content: center; gap: 16px; flex-wrap: wrap; }
.hc-btn { width:55%;font-size: 12px; font-weight: 600; letter-spacing: 0.1em; text-transform: uppercase; text-decoration: none; background: var(--p); color: #fff; padding: 14px 36px; border-radius: 4px; transition: opacity 0.2s; }
.hc-btn:hover { opacity: 0.88; }
.hc-btn-text { font-size: 13px; font-weight: 400; text-decoration: none; color: var(--muted); border-bottom: 1px solid var(--border); padding-bottom: 2px; transition: color 0.18s, border-color 0.18s; }
.hc-btn-text:hover { color: var(--p); border-color: var(--p); }

/* CARDS ROW */
.cards-row { display: flex; align-items: stretch; max-width: 900px; margin: 0 auto; width: 100%; padding: 0 40px 60px; gap: 0; }
.pearl-card { flex: 1; background: var(--card-bg); border: 1px solid var(--border); border-radius: 12px; padding: 28px; position: relative; }
.pc-num { position: absolute; top: 20px; right: 20px; font-family: 'Libre Baskerville', serif; font-size: 28px; font-weight: 700; color: var(--p); opacity: 0.06; line-height: 1; }
.re-num { color: var(--a); }
.pc-top { display: flex; gap: 14px; align-items: flex-start; margin-bottom: 16px; }
.pc-photo { width: 60px; height: 60px; border-radius: 10px; object-fit: cover; flex-shrink: 0; border: 1px solid var(--border); }
.pc-label { font-size: 9px; font-weight: 600; letter-spacing: 0.2em; text-transform: uppercase; color: var(--p); margin-bottom: 4px; }
.re-lbl { color: color-mix(in srgb, var(--a) 80%, #1c1a16); }
.pc-name { font-family: 'Libre Baskerville', serif; font-size: 18px; font-weight: 700; color: var(--p); }
.pc-role { font-size: 11px; color: var(--muted); margin-top: 2px; }
.pc-nmls { font-size: 10px; color: color-mix(in srgb, var(--muted) 60%, transparent); margin-top: 2px; }
.pc-separator { height: 1px; margin: 14px 0; }
.lo-sep { background: linear-gradient(90deg, var(--p), transparent); height: 2px; }
.re-sep { background: linear-gradient(90deg, var(--a), transparent); height: 2px; }
.pc-contacts { display: flex; flex-direction: column; gap: 5px; margin-bottom: 16px; }
.pc-ct { font-size: 11px; text-decoration: none; color: var(--muted); transition: color 0.18s; }
.lo-ct:hover { color: var(--p); }
.re-ct:hover { color: color-mix(in srgb, var(--a) 80%, #1c1a16); }
.pc-apply { display: block; text-align: center; text-decoration: none; font-size: 12px; font-weight: 600; background: var(--p); color: #fff; padding: 11px; border-radius: 6px; transition: opacity 0.2s; }
.pc-apply:hover { opacity: 0.88; }

/* DIVIDER */
.pearl-divider { display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 0 20px; gap: 8px; color: var(--border); }
.pd-line { width: 1px; flex: 1; background: var(--border); }
.pd-diamond { font-size: 10px; color: var(--a); opacity: 0.5; }

/* FOOTER */
.footer-strip { border-top: 1px solid var(--border); padding: 16px 60px; display: flex; align-items: center; gap: 0; margin-top: auto; }
.footer-strip span { font-size: 11px; color: var(--muted); }
.fs-sep { margin: 0 12px; color: var(--border); }

@media (max-width: 820px) {
  .cards-row { flex-direction: column; padding: 0 24px 40px; }
  .pearl-divider { flex-direction: row; padding: 12px 0; }
  .pd-line { height: 1px; width: 100%; flex: 1; }
  .nav { padding: 16px 24px; }
  .hero-center { padding: 48px 24px 36px; }
  .footer-strip { padding: 16px 24px; flex-wrap: wrap; gap: 4px; }
}
</style>
